_ = require 'underscore'
{ PowerUpItemType } = require 'common/components/power-up'
BaseDirectoryView = require './base-directory-view'
directoryLegacyPowerUps = require './directory-legacy-power-ups'
DirectoryPluginItemView = require './directory-plugin-item-view'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
React = require 'react'
t = require('views/internal/recup-with-helpers')('directory_enabled')

class DirectoryEnabledComponent extends React.Component
  displayName: 'Directory Enabled Power-Ups'

  render: t.renderable ->
    t.div '.directory-content-body', ->
      t.div '.directory-listing'

class DirectoryEnabledEmptyComponent extends React.Component
  displayName: 'Directory Enabled Power-Ups Empty State'

  render: t.renderable ->
    t.div '.directory-content-body.directory-enabled-empty', ->
      t.div '.directory-enabled-empty-text', ->
        t.p ->
          t.formatText 'there-are-no-power-ups-enabled-for-this-board'
        t.p ->
          t.formatText 'get-started-with-these-great-power-ups'
      t.div '.directory-listing'

module.exports = class DirectoryEnabledView extends BaseDirectoryView
  initialize: ({ @plugins, @currentPage, @directoryView }) ->
    super
    @listenTo @model, 'change:idOrganization change:powerUps', @frameDebounce @render
    @listenTo @model.boardPluginList, 'add remove reset', @frameDebounce @render

  getEnabledPlugins: ->
    combinedPlugins = _.flatten([@model.idPluginsEnabled(), @model.get('powerUps')])
    @enabledPlugins = _.chain combinedPlugins
      .map (idOrName) =>
        _.find @plugins, (plugin) =>
          plugin.id == idOrName || _.findWhere directoryLegacyPowerUps,
            id: plugin.id
            name: idOrName
      .compact()
      .sortBy (plugin) -> PluginIOCache.get(plugin).getName().toLowerCase()
      .value()

  # Returns 3 random plugins, but filter hidden/moderated ones first
  getPluginSuggestions: ->
    filteredPlugins = @directoryView.filterOutHiddenPlugins(@plugins)
    _.sample filteredPlugins, 3

  renderContent: ->
    @getEnabledPlugins()
    if @enabledPlugins.length
      return React.createElement DirectoryEnabledComponent
    else
      return React.createElement DirectoryEnabledEmptyComponent

  render: ->
    super
    contentContainer = @$el.find('.directory-listing')
    contentContainer.empty()

    if @enabledPlugins.length > 0
      enabledPluginViews = _.map @enabledPlugins, (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: PowerUpItemType.Description
          @currentPage
          plugin
          @directoryView
        }, plugin.id)

      @appendSubviews(enabledPluginViews, contentContainer)

    else
      powerUpSuggestionViews = _.map @getPluginSuggestions(), (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: PowerUpItemType.Description
          @currentPage
          plugin
          @directoryView
        }, plugin.id)

      @appendSubviews(powerUpSuggestionViews, contentContainer)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-enabled-view.coffee